__turbopack_context__.v({
  "backButton": "BackToDirectoryButton-module__o8ci0a__backButton",
});
